import React from 'react';
import ChatIcon from './ChatIcon';

export default function ChatSessions({ chats, activeId, isSending, onNew, onSelect, onDelete }) {
  return (
    <div className="chat-sessions">
      <div className="chat-brand"><span className="chat-brand-mark"><ChatIcon name="drop" /></span><span>Agua André</span></div>
      <button className="chat-new" onClick={onNew} disabled={isSending}><ChatIcon name="plus" />Nuevo chat</button>
      <p className="chat-sessions-label">Sesiones</p>
      <nav className="chat-session-list" aria-label="Sesiones">
        {chats.map((chat) => (
          <div className={`chat-session ${chat.id === activeId ? 'is-active' : ''}`} key={chat.id}>
            <button className="chat-session-select" onClick={() => onSelect(chat.id)} disabled={isSending} aria-current={chat.id === activeId ? 'page' : undefined} title={chat.title}>
              <ChatIcon name="chat" /><span>{chat.title}</span>
            </button>
            <button className="chat-session-delete" onClick={() => onDelete(chat.id)} disabled={isSending} aria-label="Eliminar chat" title="Eliminar chat"><ChatIcon name="trash" /></button>
          </div>
        ))}
      </nav>
      <div className="chat-model"><span className="chat-model-dot" /><span>GPT-6 Luna</span><span className="chat-model-env">Test</span></div>
    </div>
  );
}
